module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-13.00acec04.svg";